import React from "react";
// Components
import SchemaComponent from "components/CBSchema";
import SEO from "components/CBSEO";
import InsuranceSection from "components/InsuranceSection";
import ResourcesSlider from "pages/TherapyHub/components/resourcesSlider";
import TextBlock from "components/TextBlock";
import { ImageContainer } from "styles/components/imageContainer";
import StartYourJourney from "pages/TherapyHub/components/startYourJourney";
import FAQContent from "components/CBFAQ";
import GetStartedToday from "pages/TherapyHub/components/GetStartedToday";
import TherapyOptions from "components/TherapyOptions";
import CBDivider from "components/CBDivider";
import { TwoColumnSection } from "styles/components/twoColumnSection";
// Styled Components
import { StyledMainPageContainer } from "index.styles";
// Utils
import { constructSchemaData } from "utils/helpers/constructSchemaData";
// Data
import insuranceOptionsSchemaData from "./schema.organization.json";
import seoData from "./seo.data.json";
import insuranceOptionsHubContent from "./insuranceOptionsHubContent.data.json";
import useDynamicPageRenderer from "utils/hooks/useDynamicPageRenderer";

const componentMap = {
  "TwoColumnSection": TwoColumnSection,
  "InsuranceSection": InsuranceSection,
  "ResourcesSlider": ResourcesSlider,
  "TextBlock": TextBlock,
  "TherapyOptions": TherapyOptions,
  "ImageContainer": ImageContainer,
  "StartYourJourney": StartYourJourney,
  "Faq": FAQContent,
  "GetStartedToday": GetStartedToday,
  "Divider": CBDivider,
};

const SPREAD_PROPS_COMPONENTS = [
  "DynamicHero",
  "TextBlock",
  "ThreeColumnSection",
  "Testimonials",
  "HowItWorks",
  "TwoColumnSection",
  "TherapyOptions",
];

const InsuranceOptionsHub = () => {
  const content = insuranceOptionsHubContent;
  const renderedComponents = useDynamicPageRenderer(content, componentMap, SPREAD_PROPS_COMPONENTS);
  const schemaData = constructSchemaData(insuranceOptionsSchemaData.url, insuranceOptionsSchemaData.breadcrumbs);
  return (
    <StyledMainPageContainer id="insurance-options-page">
      <SchemaComponent schemas={schemaData} />
      <SEO title={seoData.title} description={seoData.description} canonicalUrl={seoData.canonicalUrl} />
      {renderedComponents}
    </StyledMainPageContainer>
  );
};

export default InsuranceOptionsHub;
